// Create class
const CREATE_CLASS_OPERATION = 'create';
export function isCreateClassOperation(operation) {
    return operation.type === CREATE_CLASS_OPERATION;
}
export function createClass(entity = {}) {
    return {
        type: CREATE_CLASS_OPERATION,
        entity
    };
}
// Modify class
const MODIFY_CLASS_OPERATION = 'modify';
export function isModifyClassOperation(operation) {
    return operation.type === MODIFY_CLASS_OPERATION;
}
export function modifyClass(id, entity) {
    return {
        type: MODIFY_CLASS_OPERATION,
        id,
        entity
    };
}
// Create relationship
const CREATE_RELATIONSHIP_OPERATION = 'create-relation';
export function isCreateRelationshipOperation(operation) {
    return operation.type === CREATE_RELATIONSHIP_OPERATION;
}
export function createRelationship(entity) {
    return {
        type: CREATE_RELATIONSHIP_OPERATION,
        entity
    };
}
// Modify relationship
const MODIFY_RELATIONSHIP_OPERATION = 'modify-relation';
export function isModifyRelationOperation(operation) {
    return operation.type === MODIFY_RELATIONSHIP_OPERATION;
}
export function modifyRelation(id, entity) {
    return {
        type: MODIFY_RELATIONSHIP_OPERATION,
        id,
        entity
    };
}
// Create generalization
const CREATE_GENERALIZATION_OPERATION = 'create-generalization';
export function isCreateGeneralizationOperation(operation) {
    return operation.type === CREATE_GENERALIZATION_OPERATION;
}
export function createGeneralization(entity) {
    return {
        type: CREATE_GENERALIZATION_OPERATION,
        entity
    };
}
// Modify generalization
const MODIFY_GENERALIZATION_OPERATION = 'modify-generalization';
export function isModifyGeneralizationOperation(operation) {
    return operation.type === MODIFY_GENERALIZATION_OPERATION;
}
export function modifyGeneralization(id, entity) {
    return {
        type: MODIFY_GENERALIZATION_OPERATION,
        id,
        entity
    };
}
// Delete entity
const DELETE_ENTITY_OPERATION = 'delete';
export function isDeleteEntityOperation(operation) {
    return operation.type === DELETE_ENTITY_OPERATION;
}
export function deleteEntity(id) {
    return {
        type: DELETE_ENTITY_OPERATION,
        id
    };
}
//# sourceMappingURL=operations.js.map